import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import "./Technical.scss";
class Technical extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}
  componentDidUpdate(prevProps, prevState, snapshot) {}

  render() {
    return (
      <>
        <div style={{ backgroundColor: "#000000", paddingBottom: 10 }}>
          <div className="container">
            <div className="tb-title">
              <FormattedMessage id="product.a5.technical.a1" />
            </div>
            <table className="tb technical-tb">
              <tbody>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a2" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a3" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a4" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a5" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a6" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a7" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a8" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a9" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a10" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a11" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a12" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a13" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a14" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a15" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a16" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a17" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a18" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a19" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a20" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a21" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a22" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a23" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a24" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a25" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a26" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a27" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a28" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a29" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a30" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a31" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a32" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a33" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a34" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a35" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a36" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a37" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a38" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a39" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a40" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a41" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a42" />
                  </td>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a43" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-key">
                    <FormattedMessage id="product.a5.technical.a44" />
                  </td>
                </tr>
              </tbody>
            </table>
            <h4 style={{ marginTop: 50, marginBottom: 20, color: "#ffffff" }}>
              <FormattedMessage id="product.a5.technical.a45" />
            </h4>
            <table className="tb product-parameters">
              <tbody>
                <tr>
                  <td className="tb-col1" rowSpan={7}>
                    <FormattedMessage id="product.a5.technical.a46" />
                  </td>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a47" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a48" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a49" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a50" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a51" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a52" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a53" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a54" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a55" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a56" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a57" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a58" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a59" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a60" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col1" rowSpan={3}>
                    <FormattedMessage id="product.a5.technical.a61" /> &amp;
                    <FormattedMessage id="product.a5.technical.a62" />
                  </td>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a63" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a64" />
                    <br />
                    <FormattedMessage id="product.a5.technical.a65" />
                    <br />
                    <FormattedMessage id="product.a5.technical.a66" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a67" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a68" />
                    <br />
                    <FormattedMessage id="product.a5.technical.a69" /> <br />
                    <FormattedMessage id="product.a5.technical.a70" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a71" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a72" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col1" rowSpan={2}>
                    <FormattedMessage id="product.a5.technical.a73" />
                  </td>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a74" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a75" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a76" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a77" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col1" rowSpan={6}>
                    <FormattedMessage id="product.a5.technical.a78" />
                  </td>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a79" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a80" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a81" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a82" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a83" />
                  </td>
                  <td className="tb-col3">
                    &lt;
                    <FormattedMessage id="product.a5.technical.a84" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a85" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a86" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a87" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a88" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a89" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a90" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col1" rowSpan={8}>
                    <FormattedMessage id="product.a5.technical.a91" />
                  </td>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a92" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a93" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a94" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a95" /> <br />
                    <FormattedMessage id="product.a5.technical.a96" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a97" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a98" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a99" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a100" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a101" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a102" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a103" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a104" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a105" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a106" /> <br />
                    <FormattedMessage id="product.a5.technical.a107" /> <br />
                    <FormattedMessage id="product.a5.technical.a108" />
                    <br />
                    <FormattedMessage id="product.a5.technical.a109" />
                    <br />
                    <FormattedMessage id="product.a5.technical.a110" />
                  </td>
                </tr>
                <tr>
                  <td className="tb-col2">
                    <FormattedMessage id="product.a5.technical.a111" />
                  </td>
                  <td className="tb-col3">
                    <FormattedMessage id="product.a5.technical.a112" />
                  </td>
                </tr>
              </tbody>
            </table>
            {/* <button
              className="order-now-bottom-btn"
              onClick={() => {
                this.props.history.push("/order/a5");
              }}
            >
              <FormattedMessage id="home.slider.a4" />
            </button> */}
          </div>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Technical)
);
